var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('Header',{attrs:{"current-page":_vm.currentPage}}),_c('main',{staticClass:"layout__main"},[_vm._t("default")],2),(_vm.currentPage !== 'home')?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }